import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CardActionRadiusConstantType,
    CardActionDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getHitArea
} from "../../../../helpers/theme/control";

export const CARD_ACTION_SKELETON_RATIO = 2;

export const getCardActionRadius = ({
    controlHeights,
    typography,
    radiuses,
    borders,
    inset
}: CardActionRadiusConstantType): number => {
    return concentric({
        inset: inset - (controlHeights.small - typography.titleMediumSize.lineHeight) / 2 + borders.line,
        outer: radiuses.surface,
        role: radiuses.actions
    });
};

const stylesheet = StyleSheet.create({
    passThrough: {
        pointerEvents: "box-none"
    },
    hiddenItems: {
        pointerEvents: "none",
        position: "absolute",
        opacity: 0
    },
    items: {
        flexDirection: "row",
        alignItems: "center"
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    controlHeights,
    touchTargets,
    pointerType,
    typography,
    spaces
}: CardActionDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: controlHeights.small,
        touchTargets,
        pointerType
    });

    const styles = {
        container: {
            marginVertical: (typography.titleMediumSize.lineHeight - hitArea.minHeight) / 2,
            minHeight: hitArea.minHeight,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        items: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
